import { render, staticRenderFns } from "./LsSection.vue?vue&type=template&id=ffd1fc46&scoped=true&"
import script from "./LsSection.vue?vue&type=script&lang=js&"
export * from "./LsSection.vue?vue&type=script&lang=js&"
import style0 from "./LsSection.vue?vue&type=style&index=0&id=ffd1fc46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd1fc46",
  null
  
)

export default component.exports